import { createAPI } from '@common'

export default {
  // 新建抽奖活动
  saveLottery: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0sbggmf0tbwf', 'post', config),
  // 删除抽奖活动
  deleteLottery: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0sbggmf0efmfuf', 'post', config),
  // 发布抽奖活动
  publishLottery: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0sbggmf0qvcmjti', 'post', config),
  // 撤回抽奖活动
  revokeLottery: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0sbggmf0sfwplf', 'post', config),
  // e5 操作
  postAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0f60bdujpot0qptubdujpo', 'get', config, {
        neverLoading: true,
    }),
  // 获取详情
  getLotteryDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0sbggmf0efubjm', 'get', config, {
      neverLoading: true
    }),
  // 获取抽奖活动预览链接
  getLotteryPreviewUrl: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0sbggmf0qsfwjfx', 'post', config),
  // 抽奖数据
  lotteryDataInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0sbggmf0sbggmfEbub', 'post', config),
  // 奖品数据
  prizeDataInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0sbggmf0qsj{fEbub', 'get', config),
  // 抽奖奖品核销
  verifyWinningLottery: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0sbggmfxjoojoh0wfsjgz', 'post', config),
  // 抽奖奖品取消核销¶
  cancelVerifyWinningLottery: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0sbggmfxjoojoh0dbodfmWfsjgz', 'post', config),
  // 抽奖奖品设为过期
  expireWinningLottery: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0sbggmfxjoojoh0fyqjsf', 'post', config),
  // 抽奖奖品取消过期
  cancelExpireWinningLottery: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0sbggmfxjoojoh0dbodfmFyqjsf', 'post', config),
  // 抽奖记录导出
  exportWinningLottery: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0sbggmfxjoojoh0fyqpsu', 'post', config),
  getMemberLevels: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20nfncfs`fyqfsjfodf0hfuFyqfsjfodfMfwfmMjtu', 'get', config),
  // 获取奖项的默认图标
  getLotteryDefaultIcon: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0sbggmf0qsj{fEfgbvmuJdpo', 'get', config, {
      neverLoading: true
    }),
}
